import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./Pages/Home";
import Controller from "./Pages/Controller";
import LiveMatch from "./Pages/LiveMatch";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/controller" element={<Controller />} />
        <Route path="/live-match/:matchId" element={<LiveMatch />} />
        <Route path="/court/:court" element={<LiveMatch />} />
      </Routes>
    </Router>
  );
};

export default App;
